//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AdminControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    generateBundle(type: Type): Promise<void> {
        let url_ = this.baseUrl + "/admin/opa/bundles/generate/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateBundle(_response);
        });
    }

    protected processGenerateBundle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthenticationControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    test(): Promise<void> {
        let url_ = this.baseUrl + "/auth/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthorizationControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getEmployeesInfo(capability: string | undefined, employeeIds: number[]): Promise<EmployeesAuthzInfoResultDto> {
        let url_ = this.baseUrl + "/authz/employees/info?";
        if (capability === null)
            throw new Error("The parameter 'capability' cannot be null.");
        else if (capability !== undefined)
            url_ += "capability=" + encodeURIComponent("" + capability) + "&";
        if (employeeIds === undefined || employeeIds === null)
            throw new Error("The parameter 'employeeIds' must be defined and cannot be null.");
        else
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeesInfo(_response);
        });
    }

    protected processGetEmployeesInfo(response: Response): Promise<EmployeesAuthzInfoResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeesAuthzInfoResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeesAuthzInfoResultDto>(null as any);
    }

    capabilitiesCheck(body: CapabilityCheckInputDto): Promise<CapabilityCheckDto> {
        let url_ = this.baseUrl + "/authz/me/capabilities-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCapabilitiesCheck(_response);
        });
    }

    protected processCapabilitiesCheck(response: Response): Promise<CapabilityCheckDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CapabilityCheckDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CapabilityCheckDto>(null as any);
    }
}

export class PreferencesControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getPreferences(keys: string[] | undefined): Promise<UserPreferencesDto> {
        let url_ = this.baseUrl + "/user/preferences?";
        if (keys === null)
            throw new Error("The parameter 'keys' cannot be null.");
        else if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "keys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreferences(_response);
        });
    }

    protected processGetPreferences(response: Response): Promise<UserPreferencesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPreferencesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPreferencesDto>(null as any);
    }

    setPreferences(body: UserPreferencesInputDto): Promise<void> {
        let url_ = this.baseUrl + "/user/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPreferences(_response);
        });
    }

    protected processSetPreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removePreferences(keys: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user/preferences?";
        if (keys === null)
            throw new Error("The parameter 'keys' cannot be null.");
        else if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "keys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePreferences(_response);
        });
    }

    protected processRemovePreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompanyPreferencesControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getCompanyPreferences(keys: string[] | undefined): Promise<CompanyPreferencesDto> {
        let url_ = this.baseUrl + "/company/preferences?";
        if (keys === null)
            throw new Error("The parameter 'keys' cannot be null.");
        else if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "keys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanyPreferences(_response);
        });
    }

    protected processGetCompanyPreferences(response: Response): Promise<CompanyPreferencesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPreferencesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyPreferencesDto>(null as any);
    }

    setCompanyPreferences(body: CompanyPreferencesInputDto): Promise<void> {
        let url_ = this.baseUrl + "/company/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCompanyPreferences(_response);
        });
    }

    protected processSetCompanyPreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeCompanyPreferences(keys: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/company/preferences?";
        if (keys === null)
            throw new Error("The parameter 'keys' cannot be null.");
        else if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "keys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveCompanyPreferences(_response);
        });
    }

    protected processRemoveCompanyPreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InfoControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getAppInfo(): Promise<void> {
        let url_ = this.baseUrl + "/info/app";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppInfo(_response);
        });
    }

    protected processGetAppInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getStatus(): Promise<void> {
        let url_ = this.baseUrl + "/info/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserActivityControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    /**
     * Get user activity events
     * @param filters (optional) 
     */
    list(filters: any | undefined): Promise<UserActivityEventListResultDto> {
        let url_ = this.baseUrl + "/user/activity/events?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<UserActivityEventListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserActivityEventListResultDto>(null as any);
    }

    /**
     * Add user activity events batch
     * @return Events added
     */
    addEvents(body: AddUserActivityEventsDto): Promise<void> {
        let url_ = this.baseUrl + "/user/activity/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddEvents(_response);
        });
    }

    protected processAddEvents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkflowConfigControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getWorkflows(unitId: number | undefined, processType: string | undefined): Promise<WorkflowConfigListResultDto> {
        let url_ = this.baseUrl + "/api/worklfow/?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (processType === null)
            throw new Error("The parameter 'processType' cannot be null.");
        else if (processType !== undefined)
            url_ += "processType=" + encodeURIComponent("" + processType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflows(_response);
        });
    }

    protected processGetWorkflows(response: Response): Promise<WorkflowConfigListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowConfigListResultDto>(null as any);
    }

    addWorkflowConfig(body: WorkflowConfigInputDto): Promise<WorkflowConfigDto> {
        let url_ = this.baseUrl + "/api/worklfow/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddWorkflowConfig(_response);
        });
    }

    protected processAddWorkflowConfig(response: Response): Promise<WorkflowConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkflowConfigDto.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowConfigDto>(null as any);
    }

    updateWorkflowConfig(id: string, body: WorkflowConfigInputDto): Promise<WorkflowConfigDto> {
        let url_ = this.baseUrl + "/api/worklfow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkflowConfig(_response);
        });
    }

    protected processUpdateWorkflowConfig(response: Response): Promise<WorkflowConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkflowConfigDto.fromJS(resultData202);
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowConfigDto>(null as any);
    }

    removeWorkflowConfig(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/worklfow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveWorkflowConfig(_response);
        });
    }

    protected processRemoveWorkflowConfig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProposalTrackingControllerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/iam";
    }

    getProposals(proposalId: string | undefined, proposalType: ProposalType | undefined, targetId: number | undefined, statuses: Statuses[] | undefined): Promise<ProposalTrackingListResultDto> {
        let url_ = this.baseUrl + "/api/workflows/tracking/?";
        if (proposalId === null)
            throw new Error("The parameter 'proposalId' cannot be null.");
        else if (proposalId !== undefined)
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (proposalType === null)
            throw new Error("The parameter 'proposalType' cannot be null.");
        else if (proposalType !== undefined)
            url_ += "proposalType=" + encodeURIComponent("" + proposalType) + "&";
        if (targetId === null)
            throw new Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProposals(_response);
        });
    }

    protected processGetProposals(response: Response): Promise<ProposalTrackingListResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalTrackingListResultDto>(null as any);
    }
}

export class EmployeesAuthzInfoResultDto implements IEmployeesAuthzInfoResultDto {
    data!: any;

    constructor(data?: IEmployeesAuthzInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): EmployeesAuthzInfoResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesAuthzInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IEmployeesAuthzInfoResultDto {
    data: any;
}

export class CapabilityCheckInputDto implements ICapabilityCheckInputDto {
    employees?: number[];
    units?: number[];
    capabilities!: string[];

    constructor(data?: ICapabilityCheckInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.capabilities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
        }
    }

    static fromJS(data: any): CapabilityCheckInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityCheckInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        return data;
    }
}

export interface ICapabilityCheckInputDto {
    employees?: number[];
    units?: number[];
    capabilities: string[];
}

export class CapabilityCheckDto implements ICapabilityCheckDto {
    capabilities!: string[];
    employees!: any;
    units!: any;

    constructor(data?: ICapabilityCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.capabilities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
            this.employees = _data["employees"];
            this.units = _data["units"];
        }
    }

    static fromJS(data: any): CapabilityCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        data["employees"] = this.employees;
        data["units"] = this.units;
        return data;
    }
}

export interface ICapabilityCheckDto {
    capabilities: string[];
    employees: any;
    units: any;
}

export class UserPreferencesDto implements IUserPreferencesDto {
    data!: any;

    constructor(data?: IUserPreferencesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UserPreferencesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferencesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IUserPreferencesDto {
    data: any;
}

export class UserPreferencesInputDto implements IUserPreferencesInputDto {
    data!: any;

    constructor(data?: IUserPreferencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UserPreferencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IUserPreferencesInputDto {
    data: any;
}

export class CompanyPreferencesDto implements ICompanyPreferencesDto {
    data!: any;

    constructor(data?: ICompanyPreferencesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CompanyPreferencesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPreferencesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface ICompanyPreferencesDto {
    data: any;
}

export class CompanyPreferencesInputDto implements ICompanyPreferencesInputDto {
    data!: any;

    constructor(data?: ICompanyPreferencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CompanyPreferencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPreferencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface ICompanyPreferencesInputDto {
    data: any;
}

export class UserActivitySubjectDto implements IUserActivitySubjectDto {
    userId!: number;
    employeeId?: number;

    constructor(data?: IUserActivitySubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): UserActivitySubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivitySubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IUserActivitySubjectDto {
    userId: number;
    employeeId?: number;
}

export class UserActivityEventPayloadDto implements IUserActivityEventPayloadDto {
    type!: UserActivityEventPayloadDtoType;
    target!: UserActivityEventPayloadDtoTarget;
    targetId?: string;
    resourceName?: string;

    constructor(data?: IUserActivityEventPayloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.target = _data["target"];
            this.targetId = _data["targetId"];
            this.resourceName = _data["resourceName"];
        }
    }

    static fromJS(data: any): UserActivityEventPayloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityEventPayloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["target"] = this.target;
        data["targetId"] = this.targetId;
        data["resourceName"] = this.resourceName;
        return data;
    }
}

export interface IUserActivityEventPayloadDto {
    type: UserActivityEventPayloadDtoType;
    target: UserActivityEventPayloadDtoTarget;
    targetId?: string;
    resourceName?: string;
}

export class UserActivityEventDto implements IUserActivityEventDto {
    id!: number;
    subject!: UserActivitySubjectDto;
    data?: UserActivityEventPayloadDto;
    serverTimestamp!: number;
    clientTimestamp!: number;
    clientOrder!: number;

    constructor(data?: IUserActivityEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.subject = data.subject && !(<any>data.subject).toJSON ? new UserActivitySubjectDto(data.subject) : <UserActivitySubjectDto>this.subject;
            this.data = data.data && !(<any>data.data).toJSON ? new UserActivityEventPayloadDto(data.data) : <UserActivityEventPayloadDto>this.data;
        }
        if (!data) {
            this.subject = new UserActivitySubjectDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"] ? UserActivitySubjectDto.fromJS(_data["subject"]) : new UserActivitySubjectDto();
            this.data = _data["data"] ? UserActivityEventPayloadDto.fromJS(_data["data"]) : <any>undefined;
            this.serverTimestamp = _data["serverTimestamp"];
            this.clientTimestamp = _data["clientTimestamp"];
            this.clientOrder = _data["clientOrder"];
        }
    }

    static fromJS(data: any): UserActivityEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["serverTimestamp"] = this.serverTimestamp;
        data["clientTimestamp"] = this.clientTimestamp;
        data["clientOrder"] = this.clientOrder;
        return data;
    }
}

export interface IUserActivityEventDto {
    id: number;
    subject: IUserActivitySubjectDto;
    data?: IUserActivityEventPayloadDto;
    serverTimestamp: number;
    clientTimestamp: number;
    clientOrder: number;
}

export class GetUserActivityEventsParamsDto implements IGetUserActivityEventsParamsDto {
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    employees?: number[];
    types?: Types[];

    constructor(data?: IGetUserActivityEventsParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserActivityEventsParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserActivityEventsParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IGetUserActivityEventsParamsDto {
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    employees?: number[];
    types?: Types[];
}

export class UserActivityEventInputDto implements IUserActivityEventInputDto {
    data?: UserActivityEventPayloadDto;
    timestamp!: number;
    order!: number;

    constructor(data?: IUserActivityEventInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new UserActivityEventPayloadDto(data.data) : <UserActivityEventPayloadDto>this.data;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserActivityEventPayloadDto.fromJS(_data["data"]) : <any>undefined;
            this.timestamp = _data["timestamp"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UserActivityEventInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityEventInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["timestamp"] = this.timestamp;
        data["order"] = this.order;
        return data;
    }
}

export interface IUserActivityEventInputDto {
    data?: IUserActivityEventPayloadDto;
    timestamp: number;
    order: number;
}

export class AddUserActivityEventsDto implements IAddUserActivityEventsDto {
    requestId!: string;
    events!: UserActivityEventInputDto[];

    constructor(data?: IAddUserActivityEventsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.events) {
                this.events = [];
                for (let i = 0; i < data.events.length; i++) {
                    let item = data.events[i];
                    this.events[i] = item && !(<any>item).toJSON ? new UserActivityEventInputDto(item) : <UserActivityEventInputDto>item;
                }
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(UserActivityEventInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUserActivityEventsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserActivityEventsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddUserActivityEventsDto {
    requestId: string;
    events: IUserActivityEventInputDto[];
}

export class WorkflowConfigDto implements IWorkflowConfigDto {
    id!: string;
    processType!: WorkflowConfigDtoProcessType;
    unitId!: number;
    workflow?: any;

    constructor(data?: IWorkflowConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processType = _data["processType"];
            this.unitId = _data["unitId"];
            this.workflow = _data["workflow"];
        }
    }

    static fromJS(data: any): WorkflowConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processType"] = this.processType;
        data["unitId"] = this.unitId;
        data["workflow"] = this.workflow;
        return data;
    }
}

export interface IWorkflowConfigDto {
    id: string;
    processType: WorkflowConfigDtoProcessType;
    unitId: number;
    workflow?: any;
}

export class WorkflowConfigInputDto implements IWorkflowConfigInputDto {
    id?: string;
    processType!: WorkflowConfigInputDtoProcessType;
    unitId!: number;
    workflow?: any;

    constructor(data?: IWorkflowConfigInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processType = _data["processType"];
            this.unitId = _data["unitId"];
            this.workflow = _data["workflow"];
        }
    }

    static fromJS(data: any): WorkflowConfigInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowConfigInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processType"] = this.processType;
        data["unitId"] = this.unitId;
        data["workflow"] = this.workflow;
        return data;
    }
}

export interface IWorkflowConfigInputDto {
    id?: string;
    processType: WorkflowConfigInputDtoProcessType;
    unitId: number;
    workflow?: any;
}

export class ProposalAgentDto implements IProposalAgentDto {
    userId!: number;
    roleName!: string;

    constructor(data?: IProposalAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): ProposalAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IProposalAgentDto {
    userId: number;
    roleName: string;
}

export class ApprovalStepDto implements IApprovalStepDto {
    seq!: number;
    state!: ApprovalStepDtoState;
    updatedBy!: ProposalAgentDto;
    updatedByTimestamp!: Date;
    approvers!: ProposalAgentDto[];

    constructor(data?: IApprovalStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.updatedBy = data.updatedBy && !(<any>data.updatedBy).toJSON ? new ProposalAgentDto(data.updatedBy) : <ProposalAgentDto>this.updatedBy;
            if (data.approvers) {
                this.approvers = [];
                for (let i = 0; i < data.approvers.length; i++) {
                    let item = data.approvers[i];
                    this.approvers[i] = item && !(<any>item).toJSON ? new ProposalAgentDto(item) : <ProposalAgentDto>item;
                }
            }
        }
        if (!data) {
            this.updatedBy = new ProposalAgentDto();
            this.approvers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seq = _data["seq"];
            this.state = _data["state"];
            this.updatedBy = _data["updatedBy"] ? ProposalAgentDto.fromJS(_data["updatedBy"]) : new ProposalAgentDto();
            this.updatedByTimestamp = _data["updatedByTimestamp"] ? new Date(_data["updatedByTimestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ProposalAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seq"] = this.seq;
        data["state"] = this.state;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        data["updatedByTimestamp"] = this.updatedByTimestamp ? this.updatedByTimestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApprovalStepDto {
    seq: number;
    state: ApprovalStepDtoState;
    updatedBy: IProposalAgentDto;
    updatedByTimestamp: Date;
    approvers: IProposalAgentDto[];
}

export class ProposalTrackingDto implements IProposalTrackingDto {
    proposalId!: string;
    proposalType!: ProposalTrackingDtoProposalType;
    proposalStatus!: ProposalTrackingDtoProposalStatus;
    proposalData?: any;
    createdTime!: Date;
    updatedTime!: Date;
    approvalSteps?: ApprovalStepDto[];
    targetId!: number;
    initiator!: ProposalAgentDto;
    overseers?: ProposalAgentDto[];
    administrators!: ProposalAgentDto[];

    constructor(data?: IProposalTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.approvalSteps) {
                this.approvalSteps = [];
                for (let i = 0; i < data.approvalSteps.length; i++) {
                    let item = data.approvalSteps[i];
                    this.approvalSteps[i] = item && !(<any>item).toJSON ? new ApprovalStepDto(item) : <ApprovalStepDto>item;
                }
            }
            this.initiator = data.initiator && !(<any>data.initiator).toJSON ? new ProposalAgentDto(data.initiator) : <ProposalAgentDto>this.initiator;
            if (data.overseers) {
                this.overseers = [];
                for (let i = 0; i < data.overseers.length; i++) {
                    let item = data.overseers[i];
                    this.overseers[i] = item && !(<any>item).toJSON ? new ProposalAgentDto(item) : <ProposalAgentDto>item;
                }
            }
            if (data.administrators) {
                this.administrators = [];
                for (let i = 0; i < data.administrators.length; i++) {
                    let item = data.administrators[i];
                    this.administrators[i] = item && !(<any>item).toJSON ? new ProposalAgentDto(item) : <ProposalAgentDto>item;
                }
            }
        }
        if (!data) {
            this.initiator = new ProposalAgentDto();
            this.administrators = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.proposalType = _data["proposalType"];
            this.proposalStatus = _data["proposalStatus"];
            this.proposalData = _data["proposalData"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.updatedTime = _data["updatedTime"] ? new Date(_data["updatedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["approvalSteps"])) {
                this.approvalSteps = [] as any;
                for (let item of _data["approvalSteps"])
                    this.approvalSteps!.push(ApprovalStepDto.fromJS(item));
            }
            this.targetId = _data["targetId"];
            this.initiator = _data["initiator"] ? ProposalAgentDto.fromJS(_data["initiator"]) : new ProposalAgentDto();
            if (Array.isArray(_data["overseers"])) {
                this.overseers = [] as any;
                for (let item of _data["overseers"])
                    this.overseers!.push(ProposalAgentDto.fromJS(item));
            }
            if (Array.isArray(_data["administrators"])) {
                this.administrators = [] as any;
                for (let item of _data["administrators"])
                    this.administrators!.push(ProposalAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProposalTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["proposalType"] = this.proposalType;
        data["proposalStatus"] = this.proposalStatus;
        data["proposalData"] = this.proposalData;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.approvalSteps)) {
            data["approvalSteps"] = [];
            for (let item of this.approvalSteps)
                data["approvalSteps"].push(item.toJSON());
        }
        data["targetId"] = this.targetId;
        data["initiator"] = this.initiator ? this.initiator.toJSON() : <any>undefined;
        if (Array.isArray(this.overseers)) {
            data["overseers"] = [];
            for (let item of this.overseers)
                data["overseers"].push(item.toJSON());
        }
        if (Array.isArray(this.administrators)) {
            data["administrators"] = [];
            for (let item of this.administrators)
                data["administrators"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProposalTrackingDto {
    proposalId: string;
    proposalType: ProposalTrackingDtoProposalType;
    proposalStatus: ProposalTrackingDtoProposalStatus;
    proposalData?: any;
    createdTime: Date;
    updatedTime: Date;
    approvalSteps?: IApprovalStepDto[];
    targetId: number;
    initiator: IProposalAgentDto;
    overseers?: IProposalAgentDto[];
    administrators: IProposalAgentDto[];
}

export enum Type {
    Roles = "roles",
    Units = "units",
    Managers = "managers",
    Employees = "employees",
    Modules = "modules",
    Policy = "policy",
}

export enum ProposalType {
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BONUS_PROPOSAL = "BONUS_PROPOSAL",
    JOB_OPENING = "JOB_OPENING",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    EMPLOYMENT_DETAILS_PROPOSAL = "EMPLOYMENT_DETAILS_PROPOSAL",
    POSITION_INTERNAL_PROPOSAL = "POSITION_INTERNAL_PROPOSAL",
}

export enum Statuses {
    PROPOSED = "PROPOSED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

export class UserActivityEventListResultDto implements IUserActivityEventListResultDto {
    data!: UserActivityEventDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IUserActivityEventListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new UserActivityEventDto(item) : <UserActivityEventDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserActivityEventDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): UserActivityEventListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityEventListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IUserActivityEventListResultDto {
    data: IUserActivityEventDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class WorkflowConfigListResultDto implements IWorkflowConfigListResultDto {
    data!: WorkflowConfigDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IWorkflowConfigListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new WorkflowConfigDto(item) : <WorkflowConfigDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WorkflowConfigDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): WorkflowConfigListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowConfigListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IWorkflowConfigListResultDto {
    data: IWorkflowConfigDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export class ProposalTrackingListResultDto implements IProposalTrackingListResultDto {
    data!: ProposalTrackingDto[];
    total?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IProposalTrackingListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ProposalTrackingDto(item) : <ProposalTrackingDto>item;
                }
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProposalTrackingDto.fromJS(item));
            }
            this.total = _data["total"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): ProposalTrackingListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalTrackingListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IProposalTrackingListResultDto {
    data: IProposalTrackingDto[];
    total?: number;
    offset?: number;
    limit?: number;
}

export enum UserActivityEventPayloadDtoType {
    Read = "read",
    Write = "write",
}

export enum UserActivityEventPayloadDtoTarget {
    Employee = "employee",
    Unit = "unit",
    Company = "company",
    Other = "other",
}

export enum Types {
    Read = "read",
    Write = "write",
}

export enum WorkflowConfigDtoProcessType {
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BONUS_PROPOSAL = "BONUS_PROPOSAL",
    JOB_OPENING = "JOB_OPENING",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    EMPLOYMENT_DETAILS_PROPOSAL = "EMPLOYMENT_DETAILS_PROPOSAL",
    POSITION_INTERNAL_PROPOSAL = "POSITION_INTERNAL_PROPOSAL",
}

export enum WorkflowConfigInputDtoProcessType {
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BONUS_PROPOSAL = "BONUS_PROPOSAL",
    JOB_OPENING = "JOB_OPENING",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    EMPLOYMENT_DETAILS_PROPOSAL = "EMPLOYMENT_DETAILS_PROPOSAL",
    POSITION_INTERNAL_PROPOSAL = "POSITION_INTERNAL_PROPOSAL",
}

export enum ApprovalStepDtoState {
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    PENDING = "PENDING",
}

export enum ProposalTrackingDtoProposalType {
    ALLOWANCE_PROPOSAL = "ALLOWANCE_PROPOSAL",
    BENEFIT_PROPOSAL = "BENEFIT_PROPOSAL",
    BILLABLE_HOURS = "BILLABLE_HOURS",
    BONUS_PROPOSAL = "BONUS_PROPOSAL",
    JOB_OPENING = "JOB_OPENING",
    SALARY_PROPOSAL = "SALARY_PROPOSAL",
    EMPLOYMENT_DETAILS_PROPOSAL = "EMPLOYMENT_DETAILS_PROPOSAL",
    POSITION_INTERNAL_PROPOSAL = "POSITION_INTERNAL_PROPOSAL",
}

export enum ProposalTrackingDtoProposalStatus {
    PROPOSED = "PROPOSED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}